import { ColorModeScript } from "@chakra-ui/react";
import "config/axios";
import { ContextsProvider } from "contexts";
import * as React from "react";
import { createRoot } from "react-dom/client";
import { theme } from "theme";
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const container = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <ColorModeScript
      initialColorMode={theme.config.initialColorMode}
      type="cookie"
    />
    <ContextsProvider>
      <App />
    </ContextsProvider>
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
